export const configuration = {
  stripeKey: 'pk_test_4ZSCjcNITngIpu9K0b6cxEyy',
  stripeKeyLive: 'pk_live_4ZSC7i54mO8i1BNedFh5w2LQ'
};
